import { render, staticRenderFns } from "./AttachedFiles.vue?vue&type=template&id=4f0d7f0c&scoped=true"
import script from "./AttachedFiles.vue?vue&type=script&lang=js"
export * from "./AttachedFiles.vue?vue&type=script&lang=js"
import style0 from "./AttachedFiles.vue?vue&type=style&index=0&id=4f0d7f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d7f0c",
  null
  
)

export default component.exports